(function ($, window, undefined) {
    if (window.mg === undefined)
        window.mg = {};

    if (window.mg.ui === undefined)
        window.mg.ui = {};

    const _ = window.mg;

    const defaults = {};

    class Time {
        constructor(input, options) {
            this._$input = $(input);
            this._options = $.extend({}, defaults, options);

            return this._$input.data('ui.time') || this.init();
        }

        init() {
            if (this._$input.data('ui.time'))
                return this;

            let option = {
                time: true,
                timePattern: ['h', 'm'],
                delimiterLazyShow: true
            };

            this._cleave = new Cleave(this._$input, option);
            this._$input.data('ui.time', this).on('blur', this.onBlur);

            //_.ui.clearer(this._$input); // TODO - If we want to have the Clear button we may have to change the width of the element a bit

            return this;
        }

        onBlur(e) {
            Time.changeInputTime(e.target);
        }

        static changeInputTime(target) { // Mostly copied from oMG (which is in turn copied from T2 Admin)
            var value = $.trim(target.value);

            if (value === '')
                return;

            let parts = [],
                patternFound = false,
                patterns = [
                    { k: 'd', v: /^\d{1}$/ },
                    { k: 'dd', v: /^\d{2}$/ },
                    { k: 'ddd', v: /^\d{3}$/ },
                    { k: 'dddd', v: /^\d{4}$/ },
                    { k: 'generic', v: /^\d{1,2}(-|\.|\/|,|:)\d{1,2}$/ }
                ];

            let getParts = (format) => {
                switch (format) {
                    case 'd':
                        return [
                            parseInt(value, 10),
                            0
                        ];
                    case 'dd':
                        return [
                            parseInt(value, 10),
                            0
                        ];
                    case 'ddd':
                        return [
                            parseInt(value.substring(0, 1), 10),
                            parseInt(value.substring(1, 3), 10)
                        ];
                    case 'dddd':
                        return [
                            parseInt(value.substring(0, 2), 10),
                            parseInt(value.substring(2, 4), 10)
                        ];
                    case 'generic':
                        let p = [0, 0],
                            m = value.match(/^(\d+)(-|\.|\/|,|:)(\d+)$/);

                        if (m === null)
                            return p;

                        p[0] = parseInt(m[1], 10);

                        if (m[3].length === 1)
                            m[3] = m[3] + '0';

                        p[1] = (m[3] < 10) ? parseInt('0' + m[3], 10) : parseInt(m[3], 10);

                        return p;
                }
            };

            let isValidHour = (val) => {
                return +val <= 23;
            };

            let isValidMinute = (val) => {
                return +val <= 59;
            };

            for (var i = 0; i < patterns.length; i++) {
                if (!patternFound && patterns[i].v.test(value)) {
                    patternFound = true;
                    parts = getParts(patterns[i].k);
                }
            }

            if (patternFound && isValidHour(parts[0]) && isValidMinute(parts[1])) {
                let result = 'hh:mm'.replace(/hh/, mg.cc.padZeroes(parts[0]));
                result = result.replace(/mm/, mg.cc.padZeroes(parts[1]));

                target.value = result;
                return true;
            }

            return false;
        }

        destroy() {
            return Time.destroy(this._$input);
        }

        static destroy(input) {
            const $input = $(input);
            const instance = $input.data('ui.time');

            if (!instance)
                console.warn('The time is not initialised');

            //_.ui.clearer.destroy(instance._$input);

            instance._cleave.destroy();
            instance._$input.removeData('ui.time').off('blur', this.onBlur);

            return instance;
        }
    }

    _.ui.time = (input, options) => new Time(input, options);
    _.ui.time.destroy = (input) => Time.destroy(input);
})(jQuery, window);
